import { useCallback } from 'react';

import * as SHARED_CONSTANTS from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { CommonClaimService } from '../api';
import { DocumentInfo } from '../api/Claim/uploadSharedFileCommand';

export const useUploadAttachementsOnClaimGroup = ({
  claimGroupId,
  claimIds,
}: {
  claimGroupId?: string;
  claimIds: string[];
}) => {
  const handleUploadAttachementOnClaimGroup = useCallback(
    async ({ files }: { files: File[] }) => {
      if (!claimGroupId) {
        return [];
      }

      const responses: (BackResponseFailure | BackResponse<DocumentInfo>)[] =
        await files
          .filter((file) => !!file)
          .reduce<any>(async (acc, file) => {
            return [
              ...(await acc),
              await CommonClaimService.uploadSharedFileCommand({
                claimIds,
                file,
                documentType: SHARED_CONSTANTS.DOCUMENT_TYPES.IMAGE,
                claimGroupId,
              }),
            ];
          }, []);

      return responses;
    },
    [claimGroupId, claimIds],
  );

  return {
    handleUploadAttachementOnClaimGroup,
  };
};
